import { render, staticRenderFns } from "./sidebar-guest.vue?vue&type=template&id=a468468a&scoped=true"
import script from "./sidebar-guest.vue?vue&type=script&lang=js"
export * from "./sidebar-guest.vue?vue&type=script&lang=js"
import style0 from "./sidebar-guest.vue?vue&type=style&index=0&id=a468468a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a468468a",
  null
  
)

export default component.exports